import { useAtomValue } from 'jotai';

import { appSettingsAtom } from '@/state';

/** The `settings/app` values, kept live by `useAppSettingsListener` in the protected routes; `undefined` until loaded. */
export const useAppSettings = () => useAtomValue(appSettingsAtom);
